import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Currency = () => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [baseUrl, setBaseUrl] = useState("https://devmol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("currency");
  const [data, setData] = useState(undefined);
  const [currCode, setCurrCode] = useState("");
  const [currDesc, setCurrDesc] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyCurrCode, setEmptyCurrCode] = useState(false);
  const [emptyCurrDesc, setEmptyCurrDesc] = useState(false);
  let [duplicateVal, setDuplicateVal] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setCurrCode("");
    setCurrDesc("");
  };

  function setSelectedRow(rowid) {
    axios
      .get(`${baseUrl}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        console.log(selectRowData.currency.id);
        setSelectRowData(selectRowData);
        setCurrCode(
          selectRowData.currency.currency_code
            ? selectRowData.currency.currency_code
            : ""
        );
        setCurrDesc(
          selectRowData.currency.currency_description
            ? selectRowData.currency.currency_description
            : ""
        );
        setBtnActive(false);
      });
  }

  const handleSave = async (event) => {
    if (currCode.length == 0) {
      toast.error("Country Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyCurrCode(true);
      setEmptyInput(true);
    } else {
      setEmptyCurrCode(false);
    }

    if (currDesc.length == 0) {
      toast.error("Country Name can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyCurrDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyCurrDesc(false);
    }

    if (emptyInput !== true) {
      const inputData = {
        currency_code: currCode,
        currency_description: currDesc,
      };
      const duplicate = await data.some((el) => el.CurrCode == currCode);
      console.log(duplicate);
      if (duplicate !== true) {
        axios
          .post(`${baseUrl}${pageComponent}/store`, inputData, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          })
          .then((response) => {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This currency code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = {
        currency_code: currCode,
        currency_description: currDesc,
      };
      axios
        .post(
          `${baseUrl}${pageComponent}/${selectRowData.currency.id}/update`,
          inputData,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Please Select data Row", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.currencies);
        console.log(data.currencies);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${baseUrl}${pageComponent}/destroy/${selectRowData.currency.id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = ["Currency Code", "Currency Description"];
  const columns = ["currency_code", "currency_description"];

  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-3 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="currCode"
                    value={currCode}
                    readOnly={selectRowData !== "" ? true : false}
                    className={emptyCurrCode == true ? "border-red2" : ""}
                    onChange={(e) => setCurrCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="currDesc"
                    value={currDesc}
                    className={emptyCurrDesc == true ? "border-red2" : ""}
                    onChange={(e) => setCurrDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="text-center">
              <Col className="text-end">
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={selectRowData !== "" ? edditRow : handleSave}
                  disabled={btnActive}
                >
                  Save
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={createNewRow}
                >
                  New
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={edditRow}
                  disabled={btnActive}
                >
                  Update
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={deleteRow}
                  disabled={btnActive}
                >
                  Delete
                </Button>

                <Button className="ms-3" variant="primary" disabled={btnActive}>
                  Print
                </Button>

                <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Currency;
